import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AnimatePresence, motion } from 'framer-motion'
import { useLocalStorage } from '~/hooks/useLocalStorage'
import styled from 'styled-components'
import Space from '~/components/Space'
import { ReactComponent as CloseIcon } from '~/assets/images/modal-close.svg'
import imgBG from '~/assets/images/cross-swap-activity-bg.svg'

export const activityId = 'cross-chain-swap-activity-20241213-visited'

const Activity = () => {
  const { t } = useTranslation()
  const [cache, setCache] = useLocalStorage(activityId, false)
  const [visible, setVisible] = useState(!cache)
  const variants = {
    open: { opacity: 1 },
    close: { opacity: 0, transitionEnd: { height: 0, padding: 0, margin: 0 } },
  }

  const handleClose = () => {
    setVisible(false)
    setCache(true)
  }

  const handleGo = () => {
    // const link = 'https://tokenlon.im/blog/33278239210644'
    // window.open(link, '_blank', 'noopener,noreferrer')
  }

  const isShowBtn = false

  return (
    <AnimatePresence initial={!cache}>
      <Wrapper animate={visible ? 'open' : 'close'} variants={variants}>
        <StyledBG src={imgBG} alt="cross-swap-activity-bg" />
        <Content>
          <Title>{t('activity_spotswap_title')}</Title>
          <Description>{t('activity_spotswap_desc')}</Description>
          {isShowBtn ? (
            <GoButton onClick={handleGo}>{t('activity_spotswap_btn')}</GoButton>
          ) : (
            <Space height={40} />
          )}
        </Content>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      </Wrapper>
    </AnimatePresence>
  )
}

const Wrapper = styled(motion.div)`
  position: relative;
  width: 100%;
  max-width: 435px;
  margin-bottom: 16px;
  padding: 16px 16px 12px 16px;
  border-radius: 16px;
  background: linear-gradient(
    95deg,
    rgba(255, 255, 255, 0.7) 33.12%,
    rgba(255, 255, 255, 0.31) 75.99%
  );
`

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 10;
`

const Title = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #222226;
`

const Description = styled.p`
  margin: 0 !important;
  margin-top: 4px !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.textGrey};
`

const GoButton = styled.button`
  background: ${({ theme }) => theme.colors.btnPrimary};
  color: white;
  border: none;
  border-radius: 29px;
  margin-top: 12px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 140%;
  cursor: pointer;
  width: 100px;
`

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  padding: 0;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
`

const StyledBG = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: 1;
`

export default Activity
